'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.back = exports.bindUrl = exports.setUrl = exports.getUrl = undefined;

var _bindUrl = require('bind-url');

var _bindUrl2 = _interopRequireDefault(_bindUrl);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Action types
 */

var GET_URL = 'EFFECT_GET_URL'; /**
                                 * Imports
                                 */

var SET_URL = 'EFFECT_SET_URL';
var BIND_URL = 'EFFECT_BIND_URL';
var BACK = 'EFFECT_BACK';

/**
 * Vars
 */

var types = [GET_URL, SET_URL, BIND_URL, BACK];
var handlers = [];

/**
 * Location effects
 */

function locationMiddleware(wnd) {
  if (typeof window === 'undefined' && typeof wnd !== 'string') {
    return function () {
      return function (next) {
        return function (action) {
          return next(action);
        };
      };
    };
  }

  wnd = wnd || window;
  var handle = typeof wnd === 'string' ? serverHandle : browserHandle;

  return function (_ref) {
    var dispatch = _ref.dispatch;

    return function (next) {
      return function (action) {
        return types.indexOf(action.type) !== -1 ? Promise.resolve(handle(wnd, dispatch, action)) : next(action);
      };
    };
  };
}

/**
 * Server handler
 */

function serverHandle(url, dispatch, action) {
  switch (action.type) {
    case GET_URL:
      return url;
    case BIND_URL:
      var cb = action.payload.update;
      setTimeout(function () {
        return dispatch(cb(url));
      });
      break;
  }
}

/**
 * Browser handler
 */

function browserHandle(wnd, dispatch, action) {
  switch (action.type) {
    case GET_URL:
      return wnd.location.pathname + wnd.location.search;
    case SET_URL:
      var url = action.payload.value;

      action.payload.replace ? wnd.history.replaceState(history.state, null, url) : wnd.history.pushState(null, null, url);

      handlers.forEach(function (fn) {
        return dispatch(fn(url));
      });
      break;
    case BIND_URL:
      var cb = action.payload.update;
      (0, _bindUrl2.default)({ wnd: wnd }, function (url) {
        return dispatch(cb(url));
      });
      handlers.push(cb);
      break;
    case BACK:
      wnd.history.back();
      break;
  }
}

/**
 * Action creators
 */

function getUrl() {
  return {
    type: GET_URL
  };
}

function setUrl(url, replace) {
  return {
    type: SET_URL,
    payload: {
      value: url,
      replace: replace
    }
  };
}

function bindUrl(fn) {
  return {
    type: BIND_URL,
    payload: {
      update: fn
    }
  };
}

function back() {
  return {
    type: BACK
  };
}

/**
 * Exports
 */

exports.default = locationMiddleware;
exports.getUrl = getUrl;
exports.setUrl = setUrl;
exports.bindUrl = bindUrl;
exports.back = back;